/// Concentric reference rings at fixed nautical-mile radii around
/// each airport's center. Distances come from `airport.distanceRings`
/// — the tutorial uses [5, 10], N51 uses null (no rings).

import { Container, Graphics, Text } from 'pixi.js'
import type { CoordinateProjector } from '../geo/CoordinateProjector'
import type { Airport } from '../types/LevelData'
import { radarTheme } from './theme'

export class DistanceRingsLayer extends Container {
  constructor(airports: Airport[], projector: CoordinateProjector, pxPerNM: number) {
    super()
    for (const airport of airports) {
      // Moving airports (carriers) draw their distance rings inside
      // CarrierLayer so the rings translate with the deck.
      if (airport.motion) continue
      if (!airport.distanceRings || airport.distanceRings.length === 0) continue
      const center = projector.project(airport.centerCoordinate, true)
      for (const distNM of airport.distanceRings) {
        const radiusPx = distNM * pxPerNM
        const ring = new Graphics()
        ring.circle(center.x, center.y, radiusPx)
        ring.stroke({ width: 0.8, color: radarTheme.label, alpha: 0.25 })
        this.addChild(ring)

        const label = new Text({
          text: `${distNM} NM`,
          style: {
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            fontSize: 9,
            fill: radarTheme.label,
          },
        })
        label.alpha = 0.5
        label.position.set(center.x + radiusPx * 0.707, center.y - radiusPx * 0.707 - 10)
        this.addChild(label)
      }
    }
  }
}
